import {useSubscribeToAppSyncReconnect, useSubscribeToNotificationsQuery} from '@dms/api/appsync';
import {
  useCancelBulkOperationMutation,
  useGetBulkOperationQuery,
  useLazyGetBulkOperationQuery,
  useListBulkOperationsQuery,
  useListBulkOperationItemsQuery,
  useLazyListBulkOperationItemsQuery,
  useSubmitSelectedRecordsBulkOperationMutation,
  useRerunFailedBulkOperationMutation,
} from '@dms/api/core';

import type {BulkOperationsServices} from 'features/eag-grid';

import {notificationTypes} from '../constants/notificationTypes';
import {bulkOperationPresentation} from './bulkOperationPresentation';
import {handleApiError} from './handleApiError';

/** Shared operation resources remain available to notifications and other non-grid flows. */
export const bulkOperationsServices: BulkOperationsServices = {
  presentation: bulkOperationPresentation,
  handleApiError,
  useGetOperation: useGetBulkOperationQuery,
  useLazyGetOperation: useLazyGetBulkOperationQuery,
  useListOperations: useListBulkOperationsQuery,
  useItems: useListBulkOperationItemsQuery,
  useLazyItems: useLazyListBulkOperationItemsQuery,
  useSubmitSelected: useSubmitSelectedRecordsBulkOperationMutation,
  useRerunFailed: useRerunFailedBulkOperationMutation,
  useCancel: useCancelBulkOperationMutation,
  useProgressNotifications: (onProgress) => {
    useSubscribeToNotificationsQuery((notification) => {
      if (
        notification.type === notificationTypes.BULK_OPERATION_PROGRESS_CHANGED ||
        notification.type === notificationTypes.BULK_OPERATION_STATE_CHANGED ||
        notification.type === notificationTypes.BULK_OPERATION_RECORDS_CHANGED
      ) {
        onProgress(notification.payload);
      }
    });
  },
  useReconnectNotifications: useSubscribeToAppSyncReconnect,
};
